module.exports = __webpack_public_path__ + "img/type1.b1ceaa82.png";